import { APIServices } from './axiosCommon';

export interface AlarmDto {
  uid: number;
  machineId: string | null;
  timestampUtc: string | null;
  emailSent: boolean;
  alarmTypes: string[];
  severity: 'critical' | 'warning' | 'fault';
  label: string;
}

export const alarmsApi = {
  list: (machineId?: string) =>
    APIServices.get<{ success: boolean; data: AlarmDto[] }>('/alarms', {
      params: machineId ? { machineId } : undefined,
    }),
};
